import endpoints, { axios } from "../config/api";

function deleteProjectTemplate(projectTemplateId: number) {
  return axios.delete(endpoints.projectTemplates.delete(projectTemplateId));
}

export default deleteProjectTemplate;
